import { Injectable } from '@angular/core';
import { CollectionServiceBase } from '@portal-core/data/collection/services/collection.service.base';
import { DataService } from '@portal-core/data/common/services/data.service';
import { LogStreamRow } from '@portal-core/processes/models/log-stream-row.model';
import { LogStreamRowDataService } from './log-stream-row-data.service';

@Injectable({
  providedIn: 'root'
})
export class LogStreamRowService extends CollectionServiceBase<LogStreamRow> {
  constructor(
    private logStreamRowDataService: LogStreamRowDataService,
    protected dataService: DataService) {
    super(logStreamRowDataService, dataService);
  }
}
